import React from "react";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Share2, Facebook, Instagram, ImageDown, Twitter, MessageCircle } from "lucide-react";

export const ConcertShare = ({ event }) => {
  const { t } = useLang();
  const eventUrl = `${API}/share/events/${event.slug}`;
  const cardUrl = `${API}/events/${event.slug}/social-card.png`;
  const dateStr = new Date(event.start_date).toLocaleDateString("fr-CH", { day: "numeric", month: "long", year: "numeric" });
  const caption = `${event.title} — ${dateStr} · ${event.city}. Concert folk nordique en Suisse ! ${eventUrl} #folknordique #swisspagan`;

  const shareFacebook = () =>
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(eventUrl)}&quote=${encodeURIComponent(caption)}`, "_blank", "noopener");

  const shareInstagram = async () => {
    try { await navigator.clipboard.writeText(caption); toast.success(t("share_caption_copied")); } catch { /* clipboard blocked */ }
    window.open(cardUrl, "_blank", "noopener");
  };
  const shareX = () => window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(caption)}`, "_blank", "noopener");
  const shareWhatsApp = () => window.open(`https://wa.me/?text=${encodeURIComponent(caption)}`, "_blank", "noopener");

  return (
    <div className="bg-[#121418] border border-indigo-800/40 rounded-xl p-5 space-y-3" data-testid="concert-share">
      <div className="font-mono text-[11px] uppercase tracking-wider text-indigo-300/80 flex items-center gap-2">
        <Share2 className="w-4 h-4" /> {t("share_title")}
      </div>
      <a data-testid="event-share-card" href={cardUrl} target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center gap-2 bg-[#181A20] text-stone-200 border border-[#272A34] hover:border-indigo-500/40 px-4 py-2.5 rounded-md text-sm transition-all">
        <ImageDown className="w-4 h-4" /> {t("ev_share_card")}
      </a>
      <div className="grid grid-cols-2 gap-2">
        <button data-testid="share-facebook" onClick={shareFacebook} className="inline-flex items-center justify-center gap-2 bg-[#1877F2] hover:bg-[#1466d8] text-white px-4 py-2.5 rounded-md text-sm font-semibold transition-all">
          <Facebook className="w-4 h-4" /> Facebook
        </button>
        <button data-testid="share-x" onClick={shareX} className="inline-flex items-center justify-center gap-2 bg-black hover:bg-stone-800 text-white px-4 py-2.5 rounded-md text-sm font-semibold transition-all border border-stone-700">
          <Twitter className="w-4 h-4" /> X
        </button>
        <button data-testid="share-whatsapp" onClick={shareWhatsApp} className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1fb855] text-stone-950 px-4 py-2.5 rounded-md text-sm font-semibold transition-all">
          <MessageCircle className="w-4 h-4" /> WhatsApp
        </button>
        <button data-testid="share-instagram" onClick={shareInstagram} className="inline-flex items-center justify-center gap-2 bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF] hover:opacity-90 text-white px-4 py-2.5 rounded-md text-sm font-semibold transition-all">
          <Instagram className="w-4 h-4" /> Instagram
        </button>
      </div>
      <p className="text-[11px] text-stone-500 leading-snug">{t("share_insta_hint")}</p>
    </div>
  );
};

export default ConcertShare;
